(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("redshelf-cfi", [], factory);
	else if(typeof exports === 'object')
		exports["redshelf-cfi"] = factory();
	else
		root["redshelf-cfi"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition